<template>
    <div>
        <div class="container" style="width:100%;">
            <!-- <div style="font-size:20px;"><i class="el-icon-s-unfold grid-con-icon"></i><span style="margin-left:5px;">待办工作</span></div> -->
            <!-- <el-form :model="form" inline  style="padding-left:8px;margin-top:-20px;">
                <div style="display:flex;justify-content:flex-end;">
                    <el-button @click="onEditPlanClick(null)" type="primary">新建计划</el-button>
                </div>                
                <el-row  type="flex" style="margin-top:15px;" align="center">
                    <el-form-item label="执行日期" style="width: 500px;">
                            <el-date-picker
                                    v-model="form.dateArray"
                                    type="daterange"
                                    range-separator="至"
                                    value-format="yyyy-M-d"
                                    start-placeholder="年/月/日"
                                    end-placeholder="年/月/日">
                            </el-date-picker>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="执行状态">
                        <el-select v-model="form.planStatusIdsArr" style="width:400px;" clearable multiple  placeholder="请选择">
                            <el-option v-for="item in doStatusList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="关键字">
								<el-input v-model="form.key" class="text-width"></el-input>
					</el-form-item>
                    <el-button @click="onQuery" type="primary">检索</el-button>
                </el-row>
            </el-form> -->
            <el-table 
                :data="planList_ByCate.slice((currentPage-1)*PageSize,currentPage*PageSize)" 
                border :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="800"
                        style="width: 80%;margin-top: 10px;" ref="Table" >
                <el-table-column prop="id" align="center" sortable width="50" label="ID" ></el-table-column>
                <el-table-column prop="订单编号" align="center" sortable width="130" label="订单编号">
                    <!-- <template slot-scope="scope" >
                         <div :style="{'color':scope.row.delay==1 && scope.row.roleId==1?'red':'black'}">{{scope.row.sheetCode}}</div>
                    </template> -->
                </el-table-column>
                <!-- <el-table-column :key="Math.random()" prop="comeFrom" align="center" width="50" label="来源"></el-table-column> -->
                <!-- <el-table-column prop="订单日期" align="center" width="110" label="订单日期" >
                    <template slot-scope="scope" >
                         {{scope.row.订单日期.split('T')[0]}}
                    </template>
                </el-table-column>  -->
                <!-- <el-table-column prop="经销商简称" align="center" label="经销商简称" ></el-table-column>  -->
                <!-- <el-table-column prop="终端客户" align="center" sortable  label="终端客户" ></el-table-column> -->
                <el-table-column prop="终端客户" align="center" sortable  label="终端客户/经销商" >
                    <template slot-scope="scope" >
                         <span :style="scope.row.agentPlan?'color:red;':''">{{scope.row.agentPlan?scope.row.agentPlan+'***':scope.row.终端客户}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="产品名称" align="center" sortable label="产品名称" ></el-table-column>
                <!-- <el-table-column prop="orderId" align="center" label="订单ID" ></el-table-column> -->
                <el-table-column prop="数量" align="center" sortable width="60" label="数量" ></el-table-column>
                <el-table-column prop="跟进日期" align="center" width="200" label="跟进日期" >
                    <template slot-scope="scope" >
                        {{scope.row.planSDate.split('T')[0]}} 至  {{scope.row.planEDate.split('T')[0]}}
                    </template>
                </el-table-column> 
                <el-table-column prop="topic" align="center" sortable width="170" label="任务主题" ></el-table-column>
                <el-table-column prop="订单状态" align="center" sortable width="80" label="订单状态" ></el-table-column>
                <el-table-column prop="执行状态" align="center" sortable width="110" label="执行状态" >
                    <template slot-scope="scope" >
                        <span :style="scope.row.执行状态=='超期未执行'?'color:red;':
                            scope.row.执行状态=='执行期(未执行)'?'color:yellow':
                            scope.row.执行状态=='待执行'?'':'color:gray'">
                            {{scope.row.执行状态=='超期未执行' || scope.row.执行状态=='超期执行'?'***'+scope.row.执行状态:scope.row.执行状态}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="rowTime" align="center" sortable width="160" label="创建时间" ></el-table-column>
                <el-table-column align="center" width="140" label="编辑" >
                    <template slot-scope="scope" >
                        <!-- <el-button type="text" @click="onDoClick(scope.row)">跟进</el-button> -->
                        <el-button v-if="!scope.row.finishTime" type="text" @click="onDoClick(scope.row,true)">跟进</el-button>
                        <el-button v-else type="text" @click="onDoClick(scope.row,false)">查看</el-button>
                        <el-button type="text" @click="onEditPlanClick(scope.row)">修改</el-button>                        
                        <el-button type="text" style="color:red;" @click="onDelClick(scope.row)">删除</el-button>
                    </template>
                </el-table-column>

                 
                </el-table>

                <div class="tabListPage">
                    <el-pagination @size-change="handleSizeChange" 
                                    @current-change="handleCurrentChange" 
                                    :current-page="currentPage" 
                                    :page-sizes="pageSizes" 
                                    :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                                    :total="totalCount">
                        </el-pagination>
                </div>

                <el-dialog title="新建/编辑计划" v-if="editDialogVisible" :visible="editDialogVisible" width="60%"

                                :close-on-click-modal='false'
                                @close="editDialogVisible = false" 
                                append-to-body>
                    <edit-plan ref="editPlan" :cur-item="curItem" @close="editDialogVisible=false" @onHaveDone="setFinishOver"></edit-plan>
                
                </el-dialog>

                <el-dialog :title="setPlanTitle"  v-if="doDialogVisible" :visible="doDialogVisible" width="60%"
                                
                                :close-on-click-modal='false'
                                @close="doDialogVisible = false" 
                                append-to-body>
                    <do-plan ref="plan"  :plan-item="curItem" :is-do="isDo" @close="doDialogVisible=false" @onHaveDone="setFinishOver"></do-plan>                 
                
                </el-dialog>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getLatestMonthDateArrayByDate,getNextAndBeforeHalfYearDateArray } from "@/utils/time";
import { getToken } from "@/utils/auth";
import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";
import {getSampleArrayFromSever,getSampleLogStrToSever} from "@/utils/tools";
import {ZC_SavePlan,ZC_DelPlan,ZC_SaveResult} from "@/api/zc";
import SetFinish from './components/SetFinish.vue';
import DoPlan from './components/DoPlan.vue';
import EditPlan from './components/EditPlan.vue';

export default {
    name: 'baseform',
    components: {
        MyUploadFileFormItem,SetFinish,DoPlan,EditPlan
      },
    props: ['condition'],
    computed: {
        ...mapGetters([,'clientDictList','planList_ByCate','serviceTypeList','segList','clientOrderList','resultList','provideList'])
    },
    data() {
        return {
            form: {    
                dateArray:getNextAndBeforeHalfYearDateArray({}),
                // isValidDate:true,
                planStatusIdsArr:['执行期(未执行)','超期未执行','待执行'],
                // productArr:[],
                key:'',
            },
            props: { multiple: true },

            // 默认显示第几页
            currentPage:1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount:0,
            // 个数选择器（可修改）
            pageSizes:[20,50,100],
            // 默认每页显示的条数（可修改）
            PageSize:20,
            doStatusList:[{label:'执行期(未执行)',value:'执行期(未执行)'},{label:'超期未执行',value:'超期未执行'},{label:'待执行',value:'待执行'},{label:'超期执行',value:'超期执行'},{label:'提前执行',value:'提前执行'},{label:'如期执行',value:'如期执行'}],
            curItem:{},
            editDialogVisible:false,
            editForm:{
                id:'',
                dateArray:getLatestMonthDateArrayByDate({date:new Date(),delayNum:1, formatValue: 'yyyy-MM-dd'}),
                companyId:'',
                orderId:'',
                seg:'',
                serviceTypeId:'',
                provideTypeArr:[],
                topic:'',
                content:'',
                remark:'',
                sampleArr:[],
            },
            orderDicList:[],
            
            reverse: false,
            doDialogVisible:false,
            doForm:{
                dealDate:'',
                content:'',
                sampleArr:[],
            },
            doLog:[],
            setPlanTitle:'计划跟进',
            isDo:false,
            editForm:{},
        };
    },

    async mounted() {
        await this.$store.dispatch('zc/planStatusList');
        await this.$store.dispatch('zc/clientDictList');
        await this.$store.dispatch('zc/serviceTypeList');
        await this.$store.dispatch('zc/segList');
        await this.$store.dispatch('zc/provideList');
        
        this.onQuery();
    },


    methods: {
        async setFinishOver(){
            this.onQuery();
            this.finishDialogVisible=false;
            this.doDialogVisible=false;
            this.editDialogVisible=false;
        },

        async onEditPlanClick(item){
            // this.curItem=item;
            // this.editDialogVisible=true;
            // this.$refs.plan.init();
            this.curItem=item;
            this.editDialogVisible=true;
            // console.log('this.$refs.editPlan',this.$refs.editPlan)
            // this.$refs.editPlan.init();
        },

        async onClientChange(){
            const {companyId} = this.editForm;
            this.editForm.orderId='';
            await this.$store.dispatch("zc/clientOrderList", {
                clientIds:companyId,                
            }).then(res=>{
                this.orderDicList=[];
                this.clientOrderList.forEach(ele=>{
                    this.orderDicList.push({value:ele.id,label:ele.订单编号+'|'+ele.订单项次+':'+ele.产品名称+'('+ele.数量+')'})
                })               
                console.log('aa',this.orderDicList)
            });
        },

        async onDelClick(item){
            this.$confirm('是否确认删除？ 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {    
                        await ZC_DelPlan({userId: getToken(),id:item.id}).then(()=>{
                        this.onQuery();              
						this.$message.success('删除成功');
					})
                    })
        },

        async onDoClick(item,flag){
           this.isDo=flag;
            if (flag){
                this.setPlanTitle='计划跟进';
            }else{
                this.setPlanTitle='查看计划执行';
            }
            this.curItem=item;
            console.log('aa',this.curItem)
            this.doDialogVisible=true;
         
        },
        
        async onSaveDo(){
            const {dealDate,content,sampleArr,provideTypeArr} = this.doForm;
            if (!dealDate){
                this.$message.warning('选择服务时间')
                return;
            }
            if (!content){
                this.$message.warning('请填写服务内容')
                return;
            }
            var provideTypeIds='';
            if (provideTypeArr.length>0){
                provideTypeIds=provideTypeArr.join(',');
            }

            var samples = getSampleLogStrToSever({sampleArr})
            // console.log('aa',sampleArr,samples)   id,planId,dealDate,dealContent,samples
            await ZC_SaveResult({id:'',planId:this.curItem.id,dealDate,dealContent:content,provideTypeIds,samples});
            this.$message.success('保存成功');
            this.onQuery();
            this.doDialogVisible=false;

        },

        async onSavePlan(){
            const {id,dateArray:[sDate,eDate],companyId,orderId,seg,serviceTypeId,topic, content,remark,sampleArr} = this.editForm;
            if (!sDate) {
                this.$message.warning('请选择执行日期')
                return;
            }
            if (!companyId) {
                this.$message.warning('请选择终端客户')
                return;
            }
            if (!seg ) {
                this.$message.warning('请选择服务阶段')
                return;
            }
            if (!serviceTypeId ) {
                this.$message.warning('请选择服务类型')
                return;
            }
            if (!topic?.trim()) {
                this.$message.warning('请输入服务主题')
                return;
            }
            if (!content?.trim()) {
                this.$message.warning('请输入服务内容')
                return;
            }
            var samples = getSampleLogStrToSever({sampleArr})
            console.log('aa',sampleArr,samples)
            await ZC_SavePlan({id,companyId,orderId,seg,serviceTypeId,planSDate:sDate,planEDate:eDate,topic,content,remark,samples});
            this.$message.success('保存成功');
            this.onQuery();
            this.editDialogVisible=false;
        },

       async onQuery(){
        
        var monthSeg='';
        var servicetype='';
        var clientGrade='';
        switch (this.condition.flag) {
            case 1:
                monthSeg = this.condition.name;
                break;
            case 2:
                servicetype = this.condition.name;
                break;
            case 3:
                clientGrade = this.condition.name;
                break;
        }
        
        await this.$store.dispatch("zc/planList_ByCate", {
            monthSeg,
            servicetype,
            clientGrade,
        }).then(res=>{
            this.$refs.Table.doLayout();
            this.totalCount=this.planList_ByCate.length
            this.currentPage=1
            
        });

       },

       // 每页显示的条数
        handleSizeChange(val) {
        // 改变每页显示的条数 
        this.PageSize=val
        // 注意：在改变每页显示的条数时，要将页码显示到第一页
        this.currentPage=1
        },
        // 显示第几页
        handleCurrentChange(val) {
            // 改变默认的页数
            this.currentPage=val
        },


    }
};
</script>

<style scoped>
</style>